import React from 'react';

export const Facebook = () => (
    <g>
        <path d='M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12s12-5.383,12-12S18.617,0,12,0z M12,23C5.935,23,1,18.066,1,12
			C1,5.935,5.935,1,12,1s11,4.935,11,11C23,18.066,18.065,23,12,23z' />
        <path d='M15.839,9H14V8.478c0-0.087,0.017-0.127,0.092-0.147H15.5c0.276,0,0.5-0.224,0.5-0.5V5.524c0-0.276-0.223-0.499-0.499-0.5
			l-2.352-0.007C11.147,5.018,10,6.228,10,8.336V9H8.5C8.224,9,8,9.224,8,9.5v2C8,11.776,8.224,12,8.5,12H10v6.5
			c0,0.276,0.224,0.5,0.5,0.5h3c0.276,0,0.5-0.224,0.5-0.5V12h1.595c0.253,0,0.466-0.188,0.496-0.439l0.244-2
			c0.018-0.142-0.026-0.284-0.122-0.392C16.118,9.062,15.982,9,15.839,9z M15.152,11H13.5c-0.276,0-0.5,0.224-0.5,0.5V18h-2v-6.5
			c0-0.276-0.224-0.5-0.5-0.5H9v-1h1.5c0.276,0,0.5-0.224,0.5-0.5V8.336c0-2.319,1.618-2.319,2.148-2.319L15,6.023V7.33h-0.908
			C13.566,7.33,13,7.689,13,8.478V9.5c0,0.276,0.224,0.5,0.5,0.5h1.774L15.152,11z' />
    </g>
);